import {
  Box,
  Button,
  Grid,
  Stack,
  SvgIcon,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useContext } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { CampaignContext } from "../Context";
import { isTruthy } from "helpers/methods";
import SuggestionBox from "screens/Shared/SuggestionBox";
import { useAppSelector } from "utils/hooks";
import { selectIsFirstNameMandatory } from "redux/generalSlice";

interface CustomProps {
  setIsDesignEmailModalOpen: Function;
  design: {
    content: string;
    contentPlain: string;
    contentJson: any;
  };
  showEdit?: boolean;
}

const DesignSection = (props: CustomProps) => {
  const { managingStep, submitCampaign } = useContext(CampaignContext);
  const showEdit = props.showEdit ?? true;
  const isFirstNameMandatory = useAppSelector(selectIsFirstNameMandatory);
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  const stepCompletion = () => {
    return (
      isTruthy(submitCampaign.campaign.content) &&
      isTruthy(submitCampaign.campaign.contentJson)
    );
  };

  const getPreview = () => {
    return (
      <Stack
        height="350px"
        width="100%"
        sx={{ backgroundColor: "#DCE2EB", borderRadius: "8px" }}
        mt={2}
        alignItems="center"
        justifyContent="center"
      >
        <Box p={5}>
          {/* {parse(props.design.content)} */}
          <iframe
            srcDoc={props.design.content}
            width={mdUp ? "350px" : "100%"}
            height="250px"
            style={{
              border: "none",
              borderRadius: mdUp ? "12px" : "0px",
            }}
          />
        </Box>
      </Stack>
    );
  };

  const getNonExpandedView = () => {
    const onAnotherStep =
      managingStep !== "" && managingStep !== "design-section";
    return (
      <Stack spacing={1}>
        <Grid
          container
          gap={1}
          justifyContent="space-between"
          sx={{ opacity: onAnotherStep ? 0.5 : 1 }}
        >
          <Stack direction="row" spacing={4}>
            <SvgIcon>
              <CheckCircleIcon
                htmlColor={stepCompletion() ? "#7551D0" : "#C1C1C1"}
              />
            </SvgIcon>
            <Stack spacing={0.5}>
              <Typography variant="h4">Design</Typography>
              <Typography variant="body1">
                Craft your message with text, images, and links
              </Typography>
            </Stack>
          </Stack>
          <Stack>
            {showEdit && (
              <Button
                size="small"
                variant="outlined"
                onClick={() => props.setIsDesignEmailModalOpen(true)}
                disabled={onAnotherStep}
              >
                {`${stepCompletion() ? "Edit Design" : "Start Designing"}`}
              </Button>
            )}
          </Stack>
        </Grid>
        {submitCampaign.campaign.content && getPreview()}
        {isFirstNameMandatory && (
          <SuggestionBox title="$FIRST_NAME is required to enhance personalization." />
        )}
      </Stack>
    );
  };

  const getPage = () => {
    return getNonExpandedView();
  };

  return <Box px={3}>{getPage()}</Box>;
};

export default DesignSection;
